import Axios from '../config/Axios';

export default function authorizedFolders() {
  return Axios.get('/folder/authorized').then((oResponse) => oResponse.data);
}
